import { trackEvent } from "../core";
import type { FormularioPerguntaTipoAnalytics } from "../event-map";

// VITÓRIAS
export const vistoria_visualizar = () =>
	trackEvent("vistoria_visualizar", { tipo: "entrou_na_tela" });
export const vistoriasBuscar = (termo?: string) =>
	trackEvent("vistorias_buscar", { termo: termo || "" });
export const vistoriasFiltrar = (data_inicio: string, data_fim?: string) =>
	trackEvent("vistorias_filtrar", { data_inicio, data_fim });
export const vistoriasDataFiltrar = (data_inicio: string, data_fim?: string) =>
	trackEvent("vistorias_data_filtrar", { data_inicio, data_fim });
export const vistoriasExportar = (vistoria_id: number | string) =>
	trackEvent("vistorias_exportar", { vistoria_id });

// FORMULÁRIOS - LISTA
export const formulario_lista_visualizar = () =>
	trackEvent("formulario_lista_visualizar", { tipo: "entrou_na_tela" });
export const formulario_novo_visualizar = () =>
	trackEvent("formulario_novo_visualizar", { tipo: "entrou_na_tela" });
export const formulario_criar = (
	formulario_id?: number | string,
	nome?: string
) =>
	trackEvent("formulario_criar", {
		formulario_id,
		nome,
		tipo: "criou_formulario",
	});

export const formulariosListaBuscar = (termo?: string) =>
	trackEvent("formularios_lista_buscar", { termo: termo || "" });
export const formulariosNovoFormulario = (
	formulario_id?: number | string,
	nome?: string
) => trackEvent("formularios_novo_formulario", { formulario_id, nome });
export const formulariosNovaSecao = (
	secao_id?: number | string,
	titulo?: string
) => trackEvent("formularios_nova_secao", { secao_id, titulo });
export const formularioCompartilharLink = (formulario_id: number | string) =>
	trackEvent("formularios_compartilhar_link", { formulario_id });
export const formularioBuscarPergunta = (termo?: string) =>
	trackEvent("formularios_buscar_pergunta", { termo: termo || "" });

// FORMULÁRIOS - PERGUNTAS
export const pergunta_lista_visualizar = () =>
	trackEvent("pergunta_lista_visualizar", { tipo: "entrou_na_tela" });
export const pergunta_novo_visualizar = () =>
	trackEvent("pergunta_novo_visualizar", { tipo: "entrou_na_tela" });
export const formulariosPerguntasBuscar = (termo?: string) =>
	trackEvent("formularios_perguntas_buscar", { termo: termo || "" });
export const formulariosPerguntasNova = (
	tipo?: FormularioPerguntaTipoAnalytics,
	pergunta_id?: number | string
) =>
	trackEvent("formularios_perguntas_nova", {
		tipo: tipo || "texto",
		pergunta_id,
	});
export const formulariosAdicionarPergunta = (
	tipo: string,
	pergunta_id?: number | string
) => trackEvent("formularios_adicionar_pergunta", { tipo, pergunta_id });

// Tipos de pergunta
export const formulariosPerguntasTipoSelecao = () =>
	trackEvent("formularios_perguntas_tipo_selecao", { tipo: "selecao" });
export const formulariosPerguntasTipoData = () =>
	trackEvent("formularios_perguntas_tipo_data", { tipo: "data" });
export const formulariosPerguntasTipoHora = () =>
	trackEvent("formularios_perguntas_tipo_hora", { tipo: "hora" });
export const formulariosPerguntasTipoTexto = () =>
	trackEvent("formularios_perguntas_tipo_texto", { tipo: "texto" });
export const formulariosPerguntasTipoNumero = () =>
	trackEvent("formularios_perguntas_tipo_numero", { tipo: "numero" });
export const formulariosPerguntasTipoFoto = () =>
	trackEvent("formularios_perguntas_tipo_foto", { tipo: "foto" });
export const formulariosPerguntasTipoSimNao = () =>
	trackEvent("formularios_perguntas_tipo_sim_nao", { tipo: "sim_nao" });

// CHECKLIST
export const checklist_padrao_visualizar = (formulario_id: number | string) =>
	trackEvent("checklist_padrao_visualizar", {
		formulario_id,
		tipo: "entrou_na_tela",
	});
export const checklist_formulario_visualizar = (
	formulario_id: number | string
) =>
	trackEvent("checklist_formulario_visualizar", {
		formulario_id,
		tipo: "entrou_na_tela",
	});

// VEÍCULOS
export const veiculo_visualizar = () =>
	trackEvent("veiculo_visualizar", { tipo: "entrou_na_tela" });
export const veiculosBuscar = (termo?: string) =>
	trackEvent("veiculos_buscar", { termo: termo || "" });
export const veiculosNovo = (veiculo_id?: number | string, placa?: string) =>
	trackEvent("veiculos_novo", { veiculo_id, placa });
export const veiculosInfo = (veiculo_id: number | string) =>
	trackEvent("veiculos_info", { veiculo_id });
export const veiculo_status_visualizar = (
	veiculo_id: number | string,
	status?: string
) =>
	trackEvent("veiculos_status_visualizar", {
		veiculo_id,
		status,
		tipo: "entrou_na_tela",
	});
export const veiculosEditar = (veiculo_id: number | string) =>
	trackEvent("veiculos_editar", { veiculo_id });
export const veiculosPreventiva = (veiculo_id: number | string) =>
	trackEvent("veiculos_preventiva", { veiculo_id });

// MOTORISTAS
export const motorista_visualizar = () =>
	trackEvent("motorista_visualizar", { tipo: "entrou_na_tela" });
export const motoristaBuscar = (termo?: string) =>
	trackEvent("motorista_buscar", { termo: termo || "" });
export const motoristaCategoriasView = (categorias: string[]) =>
	trackEvent("motorista_categorias_visualizar", { categorias });
export const motoristaNovoLote = (lote_id?: number | string) =>
	trackEvent("motorista_novo_lote", { lote_id });
export const motoristaExportar = () => trackEvent("motorista_exportar", {});
export const motoristaEditar = (motorista_id: number | string) =>
	trackEvent("motorista_editar", { motorista_id });

// USUÁRIOS
export const usuario_visualizar = () =>
	trackEvent("usuario_visualizar", { tipo: "entrou_na_tela" });
export const usuariosBuscar = (termo?: string) =>
	trackEvent("usuarios_buscar", { termo: termo || "" });
export const usuariosNovo = (
	usuario_id?: number | string,
	nome?: string,
	email?: string
) => trackEvent("usuarios_novo", { usuario_id, nome, email });
export const usuarioDesativarMotorista = (
	usuario_id: number | string,
	nome?: string
) => trackEvent("usuarios_desativar_motorista", { usuario_id, nome });
export const usuarioEditarMotorista = (
	usuario_id: number | string,
	nome?: string
) => trackEvent("usuarios_editar_motorista", { usuario_id, nome });
export const usuarioLogout = () => trackEvent("usuarios_logout", {});

// RASTREAMENTO
export const rastreamento_visualizar = () =>
	trackEvent("rastreamento_visualizar", { tipo: "entrou_na_tela" });
export const rastreamentoBuscar = (termo?: string) =>
	trackEvent("rastreamento_buscar", { termo: termo || "" });
export const rastreamentoVeiculosModalAbrir = () =>
	trackEvent("rastreamento_veiculos_modal_abrir", {});

// DESPESAS
export const despesa_visualizar = () =>
	trackEvent("despesa_visualizar", { tipo: "entrou_na_tela" });
export const despesa_relatorio_visualizar = () =>
	trackEvent("despesa_relatorio_visualizar", { tipo: "entrou_na_tela" });
export const despesa_historico_visualizar = () =>
	trackEvent("despesa_historico_visualizar", { tipo: "entrou_na_tela" });

// CHECKLIST (TELA)
export const checklist_visualizar = (checklist_id?: number | string) =>
	trackEvent("checklist_visualizar", { checklist_id, tipo: "entrou_na_tela" });

// HOME / LOGIN / LANDING
export const home_visualizar = () =>
	trackEvent("home_visualizar", { tipo: "entrou_na_tela" });
export const login_visualizar = () =>
	trackEvent("login_visualizar", { tipo: "entrou_na_tela" });
export const landing_visualizar = () =>
	trackEvent("landing_visualizar", { tipo: "entrou_na_tela" });
